import React, { FC, useContext } from "react";
import { GridLegacy as Grid } from "@mui/material";

import { IPreferences } from "../../logic/api";

import EditableField, {
  EditableFieldTypes,
} from "../../components/editable/EditableField/EditableField";
import EditableGroup, {
  EditableGroupType,
} from "../../components/editable/EditableGroup/EditableGroup";
import NotchedCard from "../../components/cards/NotchedCard/NotchedCard";

import { SessionContext } from "../../utility/useSession";
import styles from "./styles";
import { useTranslation } from "react-i18next";

interface IMobileVehicleMovementSettingsProps {
  onSave: (data: Partial<IPreferences>) => Promise<boolean>;
}

export const MobileVehicleMovementSettings: FC<IMobileVehicleMovementSettingsProps> = ({ onSave }) => {
  const session = useContext(SessionContext);

  if (!session.current.site) {
    return null;
  }

  const { t } = useTranslation();


  return (
    <Grid item xs={12}>
      <NotchedCard label={t("mobileVehicleMovement.title")} style={styles.card}>
        <EditableGroup<IPreferences>
          id="mobileVehicleMovementSettings"
          editType={EditableGroupType.switchableEditing}
          data={session.current.site.preferences}
          onDataChanged={(data) => onSave({
            mobile_vehicle_movements: data.mobile_vehicle_movements,
            telematics_enabled: data.telematics_enabled,
          })}
          testId="mobile-vehicle-movement-settings"
        >
          <Grid container>

            <Grid item sm={4} xs={6}>
              <EditableField<IPreferences, boolean>
                useFullWidthWhenEditing={false}
                inputType={EditableFieldTypes.switch}
                label={t("mobileVehicleMovement.enabled")}
                onProvide={(data) =>
                  Boolean(data.mobile_vehicle_movements)
                }
                onChange={(data, value) =>
                  data.mobile_vehicle_movements = Boolean(value)
                }
                testId="settings-mobile-vehicle-movement-enabled-switch"
              />

            </Grid>
            <Grid item sm={4} xs={6}>
              <EditableField<IPreferences, boolean>
                useFullWidthWhenEditing={false}
                inputType={EditableFieldTypes.switch}
                label={t("mobileVehicleMovement.telematics")}
                onProvide={(data) =>
                  Boolean(data.telematics_enabled)
                }
                onChange={(data, value) =>
                  data.telematics_enabled = Boolean(value)
                }
                testId="settings-mobile-vehicle-movement-telematics-switch"
              />

            </Grid>
          </Grid>
        </EditableGroup>
      </NotchedCard>
    </Grid>
  );
};
